import React from 'react';
import PropTypes from 'prop-types';
import Bundle from '@saucelabs/sl-component-bundle';
import { Switch, Redirect } from 'react-router-dom';
import dynamic from '@redux-dynostore/react-redux';
import { attachReducer } from '@redux-dynostore/core';
import { SentryBoundary } from '@saucelabs/sl-component-sentry';
import { constants as sentryConstants } from '@saucelabs/sl-util-sentry';
import { LoginRequiredContainer } from '@saucelabs/sl-container-authentication';

import ContainerRoute from './components/Layout/ContainerRoute';
import CheckoutContainer from './containers/CheckoutContainer';
import CheckoutSuccessContainer from './containers/CheckoutSuccessContainer';
import SelfServeOrgAdminContainer from './containers/SelfServeOrgAdminContainer';
import PurchaseContainer from './containers/PurchaseContainer';
import CancelSubscriptionContainer from './containers/CancelSubscriptionContainer';
import EmailSupportContainer from './containers/EmailSupportContainer';
import CreditsFAQContainer from './containers/CreditsFrequentlyAskedQuestionsContainer';
import billingReducer from './reducers';

const importInvoicesBilling = () => import(/* webpackChunkName: "billingInvoice" */ './containers/InvoicesContainer');
const importBillingInformation = () => import(/* webpackChunkName: "billingInformation" */ './containers/BillingInformation');
const importActiveSubscriptions = () => import(/* webpackChunkName: "billingActiveSubscriptions" */ './containers/SubscriptionsContainer');
const importUsageDetails = () => import(/* webpackChunkName: "billingActiveSubscriptions" */ './containers/UsageDetailsContainer');

const UnifiedBilling = ({ match }) => (
  <LoginRequiredContainer>
    <SentryBoundary owner={sentryConstants.TEAMS.BILLING}>
      <SelfServeOrgAdminContainer>
        <Switch>
          <ContainerRoute
            component={(props) => (
              <Bundle load={importActiveSubscriptions}>
                {(Component) => <Component {...props} />}
              </Bundle>
            )}
            exact
            path={match.url}
          />
          <ContainerRoute
            component={(props) => (
              <Bundle load={importBillingInformation}>
                {(Component) => (
                  <Component
                    activeTab={match.url}
                    {...props}
                  />
                )}
              </Bundle>
            )}
            path={`${match.url}/billing-information`}
          />
          <ContainerRoute
            component={(props) => (
              <Bundle load={importInvoicesBilling}>
                {(Component) => (
                  <Component
                    activeTab={match.url}
                    {...props}
                  />
                )}
              </Bundle>
            )}
            exact
            path={`${match.url}/invoices`}
          />
          <ContainerRoute
            component={PurchaseContainer}
            exact
            path={`${match.url}/purchase`}
          />
          <ContainerRoute
            component={CancelSubscriptionContainer}
            exact
            path={`${match.url}/cancel-subscription`}
          />
          <ContainerRoute
            component={CheckoutSuccessContainer}
            exact
            path={`${match.url}/checkout/success`}
          />
          <ContainerRoute
            component={CheckoutContainer}
            exact
            path={`${match.url}/details`}
          />
          <ContainerRoute
            component={CheckoutContainer}
            exact
            path={`${match.url}/checkout`}
          />
          <ContainerRoute
            component={(props) => (
              <Bundle load={importUsageDetails}>
                {(Component) => (
                  <Component
                    activeTab={match.url}
                    {...props}
                  />
                )}
              </Bundle>
            )}
            exact
            path={`${match.url}/usage-details`}
          />
          <ContainerRoute
            component={EmailSupportContainer}
            exact
            path={`${match.url}/email-support`}
          />
          <ContainerRoute
            component={CreditsFAQContainer}
            exact
            path={`${match.url}/about-credits`}
          />
          <Redirect to={{ pathname: match.url }} />
        </Switch>
      </SelfServeOrgAdminContainer>
    </SentryBoundary>
  </LoginRequiredContainer>
);

UnifiedBilling.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default dynamic(
  'apps.billing', attachReducer(billingReducer),
)(UnifiedBilling);
